import { render } from "./warningPopUp.vue?vue&type=template&id=d6ed0d18&scoped=true"
import script from "./warningPopUp.vue?vue&type=script&lang=js"
export * from "./warningPopUp.vue?vue&type=script&lang=js"

import "./warningPopUp.vue?vue&type=style&index=0&id=d6ed0d18&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6ed0d18"]])

export default __exports__